import { mutations, state as stateTypes } from './types';

export default {
  [mutations.SET_DATASETS](state, datasets) {
    state[stateTypes.DATASETS] = datasets;
  },
  [mutations.SET_COLLECTIONS](state, collections) {
    state[stateTypes.COLLECTIONS] = collections;
  },
  [mutations.SET_COLLECTION](state, collection) {
    state[stateTypes.COLLECTION] = collection;
  },
  [mutations.ADD_COLLECTION](state, collection) {
    state[stateTypes.COLLECTIONS].push(collection);
  },
  [mutations.SET_LOADING](state, loading) {
    state[stateTypes.IS_LOADING] = loading;
  },
  [mutations.SET_SELECTED_DATASETS](state, selectedDatasets) {
    // May need to consider using Vue.set in the case
    // child componenets are not updating
    if (selectedDatasets.length) {
      state[stateTypes.SELECTED_DATASETS] = selectedDatasets;
    } else {
      state[stateTypes.SELECTED_DATASETS] = [];
    }
  },
  [mutations.CLEAR_SELECTED_DATASETS](state) {
    state[stateTypes.SELECTED_DATASETS] = [];
  },
  /**
   * Rename collection.
   * @param {*} state
   * @param {*} collectionId
   * @param {*} collectionName
   */
  [mutations.RENAME_COLLECTION](state, { collectionId, collectionName }) {
    state[stateTypes.COLLECTIONS].forEach(c => {
      if (c.id == collectionId) {
        c.label = collectionName;
      }
    });
  },
  [mutations.DELETE_COLLECTION](state, collectionId) {
    const collections = state[stateTypes.COLLECTIONS];
    state[stateTypes.COLLECTIONS] = collections.filter(
      collection => collection.id !== collectionId
    );
  },
  [mutations.SET_OBS_VAR_COUNTS](state, payload) {
    const { datasetId, varId, counts } = payload;
    let ovc = state[stateTypes.OBS_VAR_COUNTS];
    if (!(datasetId in ovc)) {
      ovc[datasetId] = {};
    }
    ovc[datasetId][varId] = counts;
  },
  [mutations.SET_SUBJ_VAR_COUNTS](state, payload) {
    const { datasetId, varId, counts } = payload;
    let svc = state[stateTypes.SUBJ_VAR_COUNTS];
    if (!(datasetId in svc)) {
      svc[datasetId] = {};
    }
    svc[datasetId][varId] = counts;
  },
  [mutations.CLEAR_OBS_VAR_COUNTS](state) {
    state[stateTypes.OBS_VAR_COUNTS] = {};
  },
  [mutations.CLEAR_SUBJ_VAR_COUNTS](state) {
    state[stateTypes.SUBJ_VAR_COUNTS] = {};
  },
};
